/* eslint-disable no-underscore-dangle */
import React from "react";
import { connect } from "react-redux";
import PaymentGateways from "../config/paymentGateways";

class ClearSaleInitializer extends React.Component {

  componentDidMount() {
    this.initClearSale();
  }

  componentDidUpdate(prevProps) {
    const { appKey } = this.props;

    // se appKey apareceu depois do carregamento inicial
    if (appKey && appKey !== prevProps.appKey) {
      this.initClearSale();
    }
  }

  initClearSale = () => {
    const { appKey, paymentGatewayId } = this.props;

    if (!appKey || Number.parseInt(paymentGatewayId, 10) !== PaymentGateways.ZOOP) {
      return;
    }

    // evita reinicializar em SPA
    if (window.__clearsaleLoaded) return;

    window.__clearsaleLoaded = true;

    let sessionId = sessionStorage.getItem("clearSaleSessionId");

    if (!sessionId) {
      sessionId = crypto.randomUUID();
      sessionStorage.setItem("clearSaleSessionId", sessionId);
    }

    window.csdp =
      window.csdp ||
      function () {
        (window.csdp.q = window.csdp.q || []).push(arguments);
      };

    window.csdp("app", appKey);
    window.csdp("sessionid", sessionId);

    // evita adicionar script duas vezes
    if (!document.querySelector('script[src*="device.clearsale.com.br/p/fp.js"]')) {
      const script = document.createElement("script");
      script.src = "https://device.clearsale.com.br/p/fp.js";
      script.async = true;

      document.body.appendChild(script);
    }
  };

  render() {
    return null;
  }
}

const mapStateToProps = (state) => ({
  appKey: state?.reservation?.data?.paymentInfo?.antifraud_fingerprint_id,
  paymentGatewayId: state?.reservation?.data?.paymentInfo?.payment_gateway_id
});

export default connect(mapStateToProps)(ClearSaleInitializer);